import { useRef } from 'react';
import { CommonPortalProvider } from '../../contexts/commonPortal';
import { IPopup } from '../../constants/commonPortal.constant';

const CommonPortalController = (props) => {
  const {
    component: Component,
  } = props;

  const snackbar = useRef({});
  const fsPopup = useRef({});

  const invokeRefHandler = (ref, methodName, args = [], retries = 12) => {
    const method = ref?.current?.[methodName];
    if (typeof method === 'function') {
      method(...args);
      return;
    }

    if (retries <= 0) {
      return;
    }

    setTimeout(() => {
      invokeRefHandler(ref, methodName, args, retries - 1);
    }, 50);
  };

  const handleSnackbarClose = () => {
    invokeRefHandler(snackbar, 'handleSnackbarClose');
  };

  const handleSnackbarOpen = (_propup = IPopup({})) => {
    invokeRefHandler(snackbar, 'handleSnackbarOpen', [_propup]);
  };

  const handleFSPopupClose = () => {
    invokeRefHandler(fsPopup, 'handleFSPopupClose');
  };

  const handleFSPopupOpen = (_propup = IPopup({})) => {
    invokeRefHandler(fsPopup, 'handleFSPopupOpen', [_propup]);
  };

  return (
    <CommonPortalProvider
      value={{
        ref: {
          snackbar,
          fsPopup,
        },

        handler: {
          handleSnackbarClose,
          handleSnackbarOpen,
          handleFSPopupClose,
          handleFSPopupOpen,
        },
      }}
    >
      <Component {...props} />
    </CommonPortalProvider>
  );
};

export const CommonPortalControllerHOC = (Component) => (props) => (
  <CommonPortalController component={Component} {...props} />
);

export default CommonPortalControllerHOC;
